import React, { useState } from "react";
import { services } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Services() {
  const [active, setActive] = useState(0);

  return (
    <section id="services" className="bg-[var(--navy)]" style={{ backgroundColor: "var(--navy)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal className="mb-14 md:mb-20 max-w-3xl">
          <p className="font-sans-ui tracking-wide-2 text-[0.66rem] uppercase mb-6" style={{ color: "var(--teal-light)" }}>
            Our services
          </p>
          <h2 className="font-serif-display text-[2.4rem] md:text-[3.4rem] leading-[1.08] font-300 text-cream" style={{ color: "var(--cream)" }}>
            A collective of design, consult and build expertise
          </h2>
        </Reveal>

        <div className="border-t border-white/12">
          {services.map((s, i) => (
            <Reveal key={s.id} as="div">
              <button
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className="group w-full text-left border-b border-white/12 py-8 md:py-10 grid md:grid-cols-[80px_1fr_1.1fr] gap-4 md:gap-10 items-center transition-colors duration-500"
              >
                <span className="font-sans-ui text-sm transition-colors duration-500" style={{ color: active === i ? "var(--sand)" : "rgba(246,243,238,0.4)" }}>
                  0{i + 1}
                </span>
                <h3
                  className="font-serif-display text-2xl md:text-[2.4rem] leading-tight transition-all duration-500"
                  style={{ color: active === i ? "var(--cream)" : "rgba(246,243,238,0.55)", paddingLeft: active === i ? "0.75rem" : 0 }}
                >
                  {s.title}
                </h3>
                <p
                  className="text-sm md:text-base leading-relaxed transition-opacity duration-500"
                  style={{ color: "rgba(246,243,238,0.7)", opacity: active === i ? 1 : 0.4 }}
                >
                  {s.description}
                </p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
